import { TimetableEvent } from '@dreryk/react-calendar';
import { customEventFactory } from '@dreryk/react-common';

import { AppointmentEventSlotData } from '../../AppointmentsTimetable.types';

const APPOINTMENTS_TIMETABLE_EVENT_SELECTION_EVENT = 'AppointmentsTimetableEventSelectionEvent';

export type AppointmentsTimetableEventSelectionEventDetail = {
   event: TimetableEvent<AppointmentEventSlotData>;
   eventElement: HTMLDivElement | null;
};

const [
   dispatchAppointmentsTimetableEventSelectionEvent,
   registerAppointmentsTimetableEventSelectionEventListener,
] = customEventFactory<AppointmentsTimetableEventSelectionEventDetail>(APPOINTMENTS_TIMETABLE_EVENT_SELECTION_EVENT);

export { dispatchAppointmentsTimetableEventSelectionEvent, registerAppointmentsTimetableEventSelectionEventListener };
